@if (!isUiTest) {
  <div style="height:240px;">
    <div class="portfolio-history-header-block left">Attributes of this portfolio have been edited as noted below:
    </div>
    <div class="right" style="margin-right: 1px;">
      <span class="right">
        <fa-icon id="exportLink" [icon]="faDownload" (click)="exportHistory()" class="irb-green clickable" tooltip
        [tooltipTitle]="'Export'"></fa-icon>
      </span>
    </div>
    <div style="height:210px;">
      <irb-inventory-grid
        [style.width]="'100%'"
        [style.height]="'100%'"
        [showSideBar]="false"
        [gridOptions]="gridOptions"
        [frameworkComponents]={}
      (gridReady)="onGridReady($event)"></irb-inventory-grid>
    </div>
  </div>
}
